import DocumentationButton from "components/DocumentationButton";
import { EmptystateVcsColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";
import useTypedContext from "hooks/useTypedContext";
import { VcsProvider } from "types/generated";
import { SpacesContext } from "views/Account/SpacesProvider";

import { VCS_INTEGRATIONS_DOCUMENTATION_LINK } from "./constants";
import SetupButton from "./SetupButton";

const VCSIntegrationsEmpty = ({ provider }: { provider: VcsProvider }) => {
  const { hasEntityCreateAccess } = useTypedContext(SpacesContext);

  return (
    <EmptyState title="Integrate with your source code provider" icon={EmptystateVcsColored}>
      <Box gap="large" justify="center" align="center">
        <DocumentationButton
          to={VCS_INTEGRATIONS_DOCUMENTATION_LINK}
          label="Documentation"
          analyticsPage={AnalyticsPageVCS.VCSIntegrations}
          analyticsProps={{ location: "empty-state" }}
        />

        {hasEntityCreateAccess && <SetupButton provider={provider} />}
      </Box>
    </EmptyState>
  );
};

export default VCSIntegrationsEmpty;
